import React from "react";

export function OnboardingCaret({ open }) {
  return <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    className={`h-5 w-5 shrink-0 text-slate-400 transition-transform duration-300 motion-reduce:transition-none ${open ? "rotate-90" : ""}`}>
    <path d="m9 6 6 6-6 6" />
  </svg>;
}

export function OnboardingCollapse({ open, id, children }) {
  return <div id={id} aria-hidden={!open} {...(!open ? { inert: "" } : {})}
    className="grid transition-all duration-500 ease-in-out motion-reduce:transition-none"
    style={{ gridTemplateRows: open ? "1fr" : "0fr", opacity: open ? 1 : 0 }}>
    <div className="min-h-0 overflow-hidden">{children}</div>
  </div>;
}

export function LocationDisclosure({ header, children }) {
  const [open, setOpen] = React.useState(false);
  const id = React.useId();
  return <div className="py-1">
    <button type="button" aria-expanded={open} aria-controls={id} onClick={() => setOpen(!open)}
      className="flex min-h-[48px] w-full items-center gap-3 rounded-lg px-3 py-3 text-left text-sm transition-colors hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600">
      <div className="flex flex-1 flex-wrap items-center gap-2">{header}</div>
      <OnboardingCaret open={open} />
    </button>
    <OnboardingCollapse open={open} id={id}>{children}</OnboardingCollapse>
  </div>;
}
